import React from 'react';
import { Form } from 'react-bootstrap';

const Checkbox = ({ className = '', ...props }) => {
  return <Form.Check className={`checkbox mb-3 ${className}`} custom type="checkbox" {...props} />;
};

export default Checkbox;
